export default "__VITE_ASSET__1ectMccU__"